import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const included = ['🧭 START HERE — Master Resource Index', '🌊 6 Premium Volumes', '🎁 5 Bonus Guides FREE', '📄 Complete Professional System', '🖨️ 60-Page Printable Resource Library', '🗺️ Therapeutic Maps & Chakra Diagnostic Tools', '📋 Ready-to-Use Session Protocols & Scripts', '♾️ Lifetime Access'];
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-12 sm:py-14" data-id="element-160" data-mp="1t47lhsu35r8c">
      <Reveal className="mx-auto max-w-[580px]" data-id="element-161" data-mp="1y2ray37w1l5g">
        <div id="complete-package" className="scroll-mt-4 overflow-hidden rounded-2xl border border-amber/50 bg-surface shadow-elevated" data-id="element-162" data-mp="1y0es7nub36rc">
          <div className="border-b border-amber/40 bg-amber-pale px-5 py-3 text-center text-sm font-bold text-navy" data-id="element-163" data-mp="1o30c5pcaojzk">
            🧘 Complete package — All-inclusive — No upsells — No subscriptions
          </div>
          <div className="p-7 text-center sm:p-9" data-id="element-164" data-mp="cqhh0kz210y6">
            <h2 className="font-serif text-3xl leading-tight text-navy" data-id="element-165" data-mp="huz0t7loakps">Therapeutic Reiki Guide</h2>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.12em] text-sage" data-id="element-166" data-mp="cwxi4ns5sneu">
              📦 Everything You Get Instantly
            </p>
            <ul className="mt-3 grid gap-1.5 text-left text-sm font-medium leading-relaxed text-slate sm:grid-cols-2" data-id="element-167" data-mp="qxi41stdezck">
              {included.map(item => <li key={item} data-id="element-168" data-mp="10tl7d1zyl413">{item}</li>)}
            </ul>
            <div className="mt-6 border-t border-navy/10 pt-5" data-id="element-169" data-mp="vvjk04vi2ijt">
              <p className="mb-1.5 text-xs font-extrabold tracking-wide text-navy" data-id="element-170" data-mp="vt5sg6013oh0">
                Total value $102
              </p>
              <span className="inline-block rounded-full border border-amber bg-amber-pale px-4 py-1.5 text-xs font-extrabold tracking-wide text-navy" style={{
              backgroundColor: "#F0B41B",
              backgroundImage: "none"
            }} data-id="element-171" data-mp="15lbl7hy3u9x9">
                YOU SAVE <span className="line-through" data-id="element-172" data-mp="1emsx0o4hbpg5">$75</span> USD
              </span>
              <div className="mt-3 font-serif text-6xl leading-none text-navy sm:text-7xl" data-id="element-173" data-mp="c8vbf9ouw51t">
                $27<span className="align-super text-2xl sm:text-3xl" data-id="element-174" data-mp="h6wu3tide2cr">USD</span>
              </div>
              <p className="mt-1.5 text-sm text-slate" data-id="element-175" data-mp="l99wc7xwri4s">
                One-time payment · No hidden fees · Pay in your local currency
              </p>
              <div className="mt-5" data-id="element-176" data-mp="q11fvyincnlf">
                <CTAButton href="https://therapeutic-reiki-guide.impultienda.ar/checkout" pulse size="large" data-id="element-177" data-mp="uz3a9fliw9c7">
                  GET INSTANT ACCESS
                </CTAButton>
              </div>
              <p className="mt-3 text-xs leading-5 text-slate" data-id="element-178" data-mp="14xslipiwyvjh">
                🔒 Secure Payment · 💳 Card · 🌎 Local Currency &amp; Payment Options · ⚡ Instant
                Access · ♾️ Lifetime Access
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}